document.addEventListener("DOMContentLoaded", function () {
  const loadEls = document.querySelectorAll("[data-wknd-reveal-onload]");
  requestAnimationFrame(() => {
    loadEls.forEach((el) => el.classList.add("wknd-revealed"));
  });

  const revealEls = document.querySelectorAll(
    "[data-wknd-reveal]:not([data-wknd-reveal-onload])"
  );
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("wknd-revealed");
          // Reveal once and stop watching -- content should never go blank
          // again after it has already been shown once.
          observer.unobserve(entry.target);
        }
      });
    },
    {
      // Trigger as soon as an element is *approaching* the viewport, not
      // once it's already on screen. On mobile, fast flick-scrolling covers
      // a section faster than the 0.8-1.2s fade/zoom transition can finish,
      // so the old 0px margin meant users would scroll onto content that
      // was still blank/mid-fade -- reading as a white gap. Expanding the
      // bottom of the observed area by 600px means the reveal class gets
      // added, and the fade-in finishes, *before* the section is actually
      // visible, so it's already fully shown by the time it scrolls into
      // view. Desktop scrolling is slower/more granular so this was never
      // an issue there.
      threshold: 0,
      rootMargin: "0px 0px 600px 0px",
    }
  );
  revealEls.forEach((el) => observer.observe(el));
});